export const ElectoralCardTableCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Sportello',
    path: '/sportello',
  },
  {
    name: 'Lista Tessere elettorali',
    path: '/sportello/tessere-elettorali',
  },
];
